module.exports = __webpack_public_path__ + "static/media/sellsy.c478f68a.svg";